var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 4.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 18C10.1642 18 10.5 18.3358 10.5 18.75V24.375C10.5 24.9963 11.0037 25.5 11.625 25.5H24.375C24.9963 25.5 25.5 24.9963 25.5 24.375V18.75C25.5 18.3358 25.8358 18 26.25 18C26.6642 18 27 18.3358 27 18.75V24.375C27 25.8247 25.8247 27 24.375 27H11.625C10.1753 27 9 25.8247 9 24.375V18.75C9 18.3358 9.33579 18 9.75 18Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9053 18.0065C22.1982 17.7136 22.1982 17.2387 21.9053 16.9458C21.6124 16.6529 21.1376 16.6529 20.8447 16.9458L18.961 18.8295V9.95466C18.961 9.42742 18.5335 9 18.0063 9C17.479 9 17.0516 9.42742 17.0516 9.95466L17.0516 18.8426L15.1548 16.9458C14.8619 16.6529 14.3871 16.6529 14.0942 16.9458C13.8013 17.2387 13.8013 17.7136 14.0942 18.0065L17.4694 21.3817C17.7623 21.6746 18.2372 21.6746 18.5301 21.3817L21.9053 18.0065Z",
    fill: "#777777"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 4.5,
    stroke: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.b264dc0e55b4f25d16cf85a4fd31d5f2.svg";
export { ForwardRef as ReactComponent };